// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__PdOTU","list":"styles_list__1ATVV"};